import { render, staticRenderFns } from "./VentaPasoDos.vue?vue&type=template&id=2bf586d6"
import script from "./VentaPasoDos.vue?vue&type=script&lang=js"
export * from "./VentaPasoDos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports